import { EMI } from 'shared/model/types';
import { AccStatus } from 'entities/account/model/types';
import { EventLevelType } from 'entities/notification/model/types';

export enum VerificationStatus {
  Init = 'INIT',
  Pending = 'PENDING',
  // Manual = 'PENDING_MANUAL',
  Rejected = 'REJECTED',
  Verified = 'VERIFIED',
  Completed = 'COMPLETED'
}

export enum ValidationType {
  Login = 'LOGIN',
  Confirmation = 'CONFIRMATION',
}

export enum ValidationUpdateStatus {
  NeedSMSConfirmation = 'NEED_SMS_CONFIRMATION',
  NeedTwoFAConfirmation = 'NEED_TWO_FA_CONFIRMATION',
  NeedBiometryConfirmation = 'NEED_BIOMETRY_CONFIRMATION',
  Granted = 'GRANTED',
}

export enum ValidationMethod {
  No = 'NO',
  SMS = 'SMS',
  TwoFA = 'TWO_FA',
  Biometry = 'BIOMETRY',
}

export type Address = {
  line1: string;
  line2: string;
  postalCode: string;
  city: string;
  country: number;
};

// export type Cardholder = {
//     id: number;
//     cardholderId: string;
//     iban: string;
//     cardNumber: string;
//     nameOnCard: string;
//     product: string;
//     canAddSecondaryCard: boolean;
//     status: string;
//     deliveryDate: string;
//     expirationDate: string | null;
//     activated: boolean;
// }

export type UserAuth = {
  avatarId: number;
  biometrical: boolean;
  biometricalNotification: boolean | null;
  biometryForLogin: boolean;
  biometryKey: boolean;
  business: boolean;
  email: string;
  firstName: string;
  hmacNotification: boolean;
  hmacSecret: boolean;
  id: number;
  language: string;
  lastName: string;
  migration: string | null;
  notificationLevel: EventLevelType | null;
  phone: string;
  phoneCountry: number;
  phoneVerified: boolean;
  restoreId: string;
  status: string;
  twoFactor: boolean;
  twoFactorNotification: boolean | null;
  twoFactorSecret: string | null;
  validateLogin: ValidationMethod;
  validateConfirmation: ValidationMethod;
  verified: boolean;
};

export type User = {
  id: number;
  firstName: string;
  lastName: string;
  language: string;
  phone: string;
  phoneCountry: number;
  email: string;
  emiStatuses: Record<EMI, AccStatus>;
  verified: boolean;
  phoneVerified: boolean;
  status: string;
  avatarId: number;
  migration: string | null;
  twoFactor: boolean;
  twoFactorNotification: boolean | null;
  biometrical: boolean;
  biometricalNotification: boolean | null;
  twoFactorSecret: string | null;
  hmacSecret: boolean;
  hmacNotification: boolean;
  restoreId: string;
  business: boolean;
  biometryKey: boolean;
  biometryForLogin: boolean;
  validateLogin: ValidationMethod;
  validateConfirmation: ValidationMethod;
  dateOfBirth: string;
  address: Address;
  agree: unknown;
  agreeOn: unknown;
  // cardholderIds: Cardholder[];
  incomingPaymentMessage: string | null;
  hasPrimaryToken: boolean;
  verificationStatus: VerificationStatus;
  notificationLevel: EventLevelType | null;
};
